import { Component, Input } from '@angular/core';

// Two-column "Top performing / Needs improvement" callout list used
// on Content Performance tab. Keeps top/low styling in one place.
@Component({
  selector: 'tangram-analytics-top-low-list',
  templateUrl: './analytics-top-low-list.component.html',
  styleUrls: ['./analytics-top-low-list.component.scss']
})
export class AnalyticsTopLowListComponent {
  @Input() heading = '';
  @Input() tone: 'top' | 'low' = 'top';
  @Input() rows: Array<{
    title: string;
    type: string;
    completionRate: number;
    views: number;
    engagementScore: number;
  }> = [];
}
